export const loader = `
        <div class="file__upload-inner lds-dual-ring">
            <div class="lds-dual-ring__inner"></div>
        </div>
    `;
